import { render, staticRenderFns } from "./CoTwoTehnicalProductionForm.vue?vue&type=template&id=25a1c41e&scoped=true&"
import script from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1c41e",
  null
  
)

export default component.exports